module.exports = __webpack_public_path__ + "assets/media/morning.406131e2.mp3";